import { useQuery } from '@apollo/client';
import createShopifyClient from '../clients/createShopifyClient';
import GET_ORDER_DETAILS from '../../commons/gql/remote/GetOrderDetails';

const client = createShopifyClient();

const useOrderDetails = (id: string) => useQuery(GET_ORDER_DETAILS(id), { client });

export default useOrderDetails;
